export default __webpack_public_path__ + "3b75b2f4f0ad0273df25cade3e959f1e.png";